var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivitiescomplete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3203 10C20.3203 15.5228 15.8432 20 10.3203 20C4.79746 20 0.320312 15.5228 0.320312 10C0.320312 4.47715 4.79746 0 10.3203 0C15.8432 0 20.3203 4.47715 20.3203 10Z",
    fill: "#3E732A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95783 12.9629L15.0203 5.90039C15.187 5.73372 15.3814 5.65039 15.6037 5.65039C15.8259 5.65039 16.0203 5.73372 16.187 5.90039C16.3537 6.06706 16.437 6.26511 16.437 6.49456C16.437 6.724 16.3537 6.92178 16.187 7.08789L8.54116 14.7546C8.3745 14.9212 8.18005 15.0046 7.95783 15.0046C7.73561 15.0046 7.54117 14.9212 7.3745 14.7546L3.79117 11.1712C3.6245 11.0046 3.5445 10.8068 3.55117 10.5779C3.55783 10.349 3.64478 10.1509 3.812 9.98372C3.97922 9.8165 4.17728 9.73317 4.40617 9.73372C4.63505 9.73428 4.83283 9.81761 4.9995 9.98372L7.95783 12.9629Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitiescomplete);
export default __webpack_public_path__ + "static/media/activitiescomplete.db3fe43c6de71696fa580644d8a19219.svg";
export { ForwardRef as ReactComponent };